// give me many of the same thing by length
export const many = (length, cb) => {
  return Array.apply(null, {
    length,
  }).map((_, i) => cb(i))
}